import styled from 'styled-components';

export const SoundWrapper = styled.div`
    position: absolute;
    top: 25px;
    right: 35px;
`;